import React, { useEffect } from "react";
import { Instagram, ExternalLink } from "lucide-react";

// Real Instagram Reels shared by Bindni Jewels
export const BINDNI_REELS = [
  "https://www.instagram.com/reel/DZBx0mwTraO/",
  "https://www.instagram.com/reel/Da52ybMzIHt/",
  "https://www.instagram.com/reel/DaqF1yhq5Z1/",
];

const loadInstagramScript = () => {
  if (document.getElementById("ig-embed-script")) {
    // Already loaded — retrigger parsing
    if (window.instgrm?.Embeds?.process) window.instgrm.Embeds.process();
    return;
  }
  const s = document.createElement("script");
  s.id = "ig-embed-script";
  s.async = true;
  s.src = "https://www.instagram.com/embed.js";
  document.body.appendChild(s);
};

export default function InstagramReels({ urls = BINDNI_REELS }) {
  useEffect(() => {
    loadInstagramScript();
    const t = setTimeout(() => {
      if (window.instgrm?.Embeds?.process) window.instgrm.Embeds.process();
    }, 600);
    return () => clearTimeout(t);
  }, [urls]);

  return (
    <section className="max-w-[1400px] mx-auto px-6 lg:px-10 py-24" data-testid="instagram-reels-section">
      <div className="flex flex-col items-center text-center mb-10">
        <Instagram size={22} strokeWidth={1.4} className="text-brand-maroon" />
        <a href="https://www.instagram.com/bindni_jewels" target="_blank" rel="noreferrer" className="label-tiny text-brand-gold mt-3 hover:text-brand-maroon">@bindni_jewels</a>
        <h2 className="font-serif-brand text-3xl lg:text-4xl text-brand-charcoal mt-2">Watch our Bindnis in action</h2>
        <p className="text-sm text-brand-muted mt-2 max-w-lg">Real reels from real customers · Follow us for daily inspiration and new drops.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {urls.map((url) => (
          <div key={url} className="bg-brand-ivory border border-brand-gold/25 overflow-hidden" data-testid={`reel-${url.split('/reel/')[1]?.split('/')[0]}`}>
            <blockquote
              className="instagram-media"
              data-instgrm-permalink={url}
              data-instgrm-version="14"
              data-instgrm-captioned
              style={{ background: "#FFF", border: 0, margin: 0, padding: 0, width: "100%", minHeight: "480px" }}
            >
              <a href={url} target="_blank" rel="noreferrer" className="block p-6 text-center">
                <Instagram size={40} className="mx-auto text-brand-maroon mb-3" />
                <p className="font-serif-brand text-brand-charcoal">View this Reel on Instagram</p>
                <span className="inline-flex items-center gap-1 text-xs text-brand-muted mt-2"><ExternalLink size={12} /> Opens Instagram</span>
              </a>
            </blockquote>
          </div>
        ))}
      </div>

      <div className="text-center mt-10">
        <a href="https://www.instagram.com/bindni_jewels" target="_blank" rel="noreferrer" className="btn-outline-gold inline-flex items-center gap-2" data-testid="see-more-reels-btn">
          <Instagram size={14} /> See more on Instagram
        </a>
      </div>
    </section>
  );
}
